// KPIs de Almacén — función pura sobre datos ya acotados en el cliente
// mediante consultas específicas (ver AnaliticaTab en AlmacenView.js), no
// sobre el catálogo completo de `productos` (~22.700 documentos reales de
// StelOrder, la inmensa mayoría sin stock gestionado — descargarlo entero
// para calcular estos KPIs sería justo el problema que se quiere evitar):
//
// - `productosConStock`: resultado de `where('real-stock', '>', 0)` — los
//   productos que de verdad hay en el almacén ahora mismo. Base de "valor de
//   inventario" y "nº de productos".
// - `productosConMinimo`: resultado de `where('minimum-stock', '>', 0)` —
//   los productos con un umbral de reposición configurado. Base de "stock
//   bajo" y "sin stock": mirar esto sobre el catálogo entero no tendría
//   sentido, ya que casi ningún producto de StelOrder lleva mínimo puesto.
//
// `productos` usa los mismos nombres de campo que StelOrder (name,
// sales-price, purchase-price, real-stock, minimum-stock, inactive...) tanto
// para lo importado como para lo creado a mano — ver AlmacenView.js.

export function calcularKpisAlmacen(productosConStock, productosConMinimo, movimientos) {
  const valorInventario = productosConStock.reduce((s, p) => s + (Number(p['sales-price']) || 0) * (Number(p['real-stock']) || 0), 0);
  const valorCoste      = productosConStock.reduce((s, p) => s + (Number(p['purchase-price']) || 0) * (Number(p['real-stock']) || 0), 0);

  const sinStock  = productosConMinimo.filter(p => (Number(p['real-stock']) || 0) <= 0);
  const stockBajo = productosConMinimo.filter(p => (Number(p['real-stock']) || 0) > 0 && (Number(p['real-stock']) || 0) <= (Number(p['minimum-stock']) || 0));

  const entradas = movimientos.filter(m => m.tipo === 'entrada');
  const salidas  = movimientos.filter(m => m.tipo === 'salida' || m.tipo === 'uso_orden');

  const movsPorProducto = {};
  movimientos.forEach(m => {
    if (!m.productoId) return;
    if (!movsPorProducto[m.productoId]) movsPorProducto[m.productoId] = { count: 0, nombre: m.productoNombre || m.productoId };
    movsPorProducto[m.productoId].count++;
  });
  const topProductos = Object.entries(movsPorProducto)
    .map(([productoId, v]) => ({ productoId, nombre: v.nombre, count: v.count }))
    .sort((a, b) => b.count - a.count)
    .slice(0, 5);

  return {
    totalProductos: productosConStock.length,
    valorInventario,
    valorCoste,
    margenPotencial: valorInventario - valorCoste,
    sinStock: sinStock.length,
    sinStockLista: sinStock,
    stockBajo: stockBajo.length,
    stockBajoLista: stockBajo,
    movimientosPeriodo: movimientos.length,
    entradas: entradas.length,
    salidas: salidas.length,
    unidadesEntradas: entradas.reduce((s, m) => s + (Number(m.cantidad) || 0), 0),
    unidadesSalidas: salidas.reduce((s, m) => s + (Number(m.cantidad) || 0), 0),
    topProductos,
  };
}
